import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectFertilizerProductValue } from 'services/fertilizerProducts/selectors';

const selectWithholdingPeriodDays = createDeepEqualSelector(
    makeSelectFertilizerProductValue('witholdingPeriodDays'),
    (reEntryPeriodDays) => reEntryPeriodDays
);

const makeSelectWithholdingPeriodDays =
    (): typeof selectWithholdingPeriodDays => selectWithholdingPeriodDays;

export { makeSelectWithholdingPeriodDays };
